import { styled } from '@mui/material/styles';
import { hideScrollBar } from '../../../../sharedStyles/layoutStyles';

const StyledFiltersWrapper = styled('div')(
  ({ theme }) => `
 
    width: 100%;
    max-width: 694px;
    display: flex;
    flex-direction: column;
    justify-content:center;
    position: sticky;
    margin-top: 0;
    z-index: 200;
    background-color:${theme.DS_palette.primary.white};
    border-top-right-radius: ${theme.DS_border.radius.button};
    
   ${theme.breakpoints.up('md')} {
   
       max-width: 100%;
     }
    
     ${theme.breakpoints.up('lg')} {
       top: 0;
         margin-top: 0;
          max-width: 694px;
     }
 
  `,
);

const StyledFilters = styled('div')(
  ({ theme }) => `
     display: flex;
     overflow-x: scroll;
     ${hideScrollBar}
     gap: ${theme.DS_spacing(['xxs'])};
     padding: 0;
     box-shadow: 5px 9px 24px 0px rgba(0, 0, 0, 0.07);
     
     &:after {
      content: "";
      position: absolute;
      z-index: 1;
      top: 0;
      right: 0;
      pointer-events: none;
      background-image: linear-gradient(to right, rgba(255,255,255,0), rgba(255,255,255, 0.7) 100%);
      width: 80px;
      height: 100%;
    }
   
     > * {
       flex: 0 0 auto;
     }
     > div:first-of-type {
        margin-left: ${theme.DS_spacing(['md'])}; 
     }
    
     > div:last-of-type {
        margin-right: ${theme.DS_spacing(['xxl'])}; 
     }
     ${theme.breakpoints.up('lg')} {
        padding:${theme.DS_spacing(['sm'])} 0  ${theme.DS_spacing(['xxs'])};
     }
  `,
);

export { StyledFiltersWrapper, StyledFilters };
